<template>
  <component
    :is="element"
    class="product-prices"
    :class="{ [$class('loading')]: loading }"
  >
    <span
      class="product-prices__price"
      :class="[
        classPrice,
        { 'product-prices__price--on-sale': formattedCompareAtPrice },
      ]"
    >
      <span
        v-if="varies"
        v-text="$string('product.prices.from')"
      />

      {{ formattedPrice }}
    </span>

    <span
      v-if="formattedCompareAtPrice"
      class="product-prices__compare-at-price"
      :class="classCompareAtPrice"
    >
      {{ $string('product.prices.was') }} {{ formattedCompareAtPrice }}
    </span>
  </component>
</template>

<script>

/**
 * Vue: Product prices (product-prices)
 * -----------------------------------------------------------------------------
 * Global product prices template.
 *
 * @param {String} [classCompareAtPrice] - Comare at price text classes.
 * @param {String} [classPrice] - Price text classes.
 * @param {Number|Boolean} compareAtPrice - Compare at price, in cents format.
 * @param {String} [element] - Custom element override.
 * @param {Boolean} [loading] - Loading state.
 * @param {Number} price - Product price, in cents format.
 * @param {Boolean} [varies] - Product variants vary in price.
 *
 */
export default {
  name: 'ProductPrices',

  props: {
    classCompareAtPrice: {
      type: String,
      default: 'text-other-sale-s text-other-sale-l-desktop',
    },
    classPrice: {
      type: String,
      default: 'text-body-s-regular text-body-m-regular-desktop',
    },
    compareAtPrice: {
      type: [Boolean, Number],
      default: false,
      required: true,
    },
    element: {
      type: String,
      default: 'p',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    price: {
      type: [Boolean, Number],
      default: 0,
      required: true,
    },
    varies: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Compute compare at price template.
     * @returns {String}
     */
    formattedCompareAtPrice() {
      return this.compareAtPrice && this.price < this.compareAtPrice
        ? this.$formatMoney(this.compareAtPrice)
        : ''
    },

    /**
     * Compute price template.
     * @returns {String}
     */
    formattedPrice() {
      if (this.price === false) {
        return this.$string('accessibility.loading')
      }

      if (this.price <= 0) {
        return this.$string('product.prices.free')
      }

      return this.price ? this.$formatMoney(this.price) : ''
    },
  },
}
</script>
